import { historySVC } from "app/history/service"
import { coordinateEventModule } from "coordinate/event"
import { CAMPAIGN_TAB_ID_QUERY_PARAM } from "page/model"
import { getActivePage } from "page/tools/common"
import { shapeEventModule } from "shape/event"
import { userEventModule } from "user/event"
import { ALL_FORM_PAGE_PATHS, FORM_TABS } from "./model"
import { activateFormTab } from "./tools/common"
import { checkEnvironmentIsTreeViewPreference } from "./tools/environments"
import { setIntersectionGeoTargetFeature } from "./tools/geo-targets"

export function startFormListeners(): void {
  userEventModule.on.login("form-login", () => {
    checkEnvironmentIsTreeViewPreference()
  })
  coordinateEventModule.on.onCoordinateAdd("form-coordinate-add", () => {
    setIntersectionGeoTargetFeature()
  })
  coordinateEventModule.on.onCoordinateUpdate("form-coordinate-update", () => {
    setIntersectionGeoTargetFeature()
  })
  coordinateEventModule.on.onCoordinateDelete("form-coordinate-delete", () => {
    setIntersectionGeoTargetFeature()
  })
  coordinateEventModule.on.onCoordinatesDelete("form-coordinates-delete", () => {
    setIntersectionGeoTargetFeature()
  })
  coordinateEventModule.on.onCoordinatesSet("form-coordinates-set", () => {
    setIntersectionGeoTargetFeature()
  })
  shapeEventModule.on.onShapesAdd("form-shapes-add", () => {
    setIntersectionGeoTargetFeature()
  })
  shapeEventModule.on.onShapeDelete("form-shape-delete", () => {
    setIntersectionGeoTargetFeature()
  })
  shapeEventModule.on.onShapesDelete("form-shapes-delete", () => {
    setIntersectionGeoTargetFeature()
  })
  shapeEventModule.on.onShapesSet("form-shapes-set", () => {
    setIntersectionGeoTargetFeature()
  })
  historySVC.onParameterChange(CAMPAIGN_TAB_ID_QUERY_PARAM, (_oldValue, newValue) => {
    const activePage = getActivePage()
    if (newValue && ALL_FORM_PAGE_PATHS.includes(activePage.path)) {
      activateFormTab(newValue as FORM_TABS, true)
    }
  })
}
